import React from 'react';

const SupportScreen = React.lazy(
  () => import('src/latest/src/features/resources/support/SupportScreen'),
);

const SupportTicket = React.lazy(
  () =>
    import('src/latest/src/features/resources/support-ticket/SupportTicket'),
);

export const resourcesRoutes = [
  {
    path: 'support-options',
    name: 'SupportOptions',
    component: SupportScreen,
    extact: true,
  },
  {
    path: 'support/:type',
    name: 'SupportTicket',
    component: SupportTicket,
    exact: true,
  },
];
